const initDoctorSelector = () => {
    const tabSliderSelector = "[data-slider]";
    const tabSliderArray = document.querySelectorAll(tabSliderSelector);
    const doctorSection = document.querySelector("[data-doctors-section]");
    const doctorAfterVenueSection = document.querySelector("[data-doctors-after-venue]");
    if (doctorSection || doctorAfterVenueSection) {
        const config = new CarouselConfig();
        config.sliderSelector = tabSliderSelector;
        config.cellAlign = CellAlign.center;
        config.contain = true;
        config.autoPlay = false;
        config.wrapAround = false;
        config.showArrows = false;
        config.showDots = false;
        config.groupCells = true;
        config.adaptiveHeight = true;
        config.imagesLoaded = true;
        const responsiveCarousel = new ResponsiveCarousel();
        responsiveCarousel.initCarousel(config);
        handleDoctorSection(doctorSection);
        handleDoctorSection(doctorAfterVenueSection);
    }
};
const initDoctorSelectorDuplex = () => {
    const tabSliderSelector = "[data-slider]";
    const tabSliderArray = document.querySelectorAll(tabSliderSelector);
    const doctorSection = document.querySelector("[data-doctors-section]");
    const doctorAfterVenueSection = document.querySelector("[data-doctors-after-venue]");
    if (doctorSection || doctorAfterVenueSection) {
        const config = new CarouselConfig();
        config.sliderSelector = "[data-slider]";
        config.cellAlign = CellAlign.center;
        config.contain = true;
        config.autoPlay = false;
        config.wrapAround = false;
        config.showArrows = false;
        config.showDots = false;
        config.groupCells = true;
        config.adaptiveHeight = true;
        config.imagesLoaded = true;
        const responsiveCarousel = new ResponsiveCarousel();
        responsiveCarousel.initCarousel(config);
    }
};
const handleDoctorSection = (section) => {
    const contactFormToAppend = document.querySelector("[data-contact-form-step]");
    //const contactFormToAppend: HTMLElement = document.querySelector("[data-contact-form]");
    //const cardList: NodeListOf<HTMLDivElement> = section.querySelectorAll("[data-slide]");
    const cardList = section.querySelectorAll("[data-to-append]");
    cardList.forEach((card) => {
        const radioButton = card.querySelector("[data-radio-button]");
        if (radioButton) {
            const venueContainerToAppend = document.querySelector("[data-venue-list-section]");
            const performanceId = new URL(window.location.href).searchParams.get("performanceId");
            const doctorId = new URL(window.location.href).searchParams.get("doctorId");
            const venueId = new URL(window.location.href).searchParams.get("venueId");
            const contactForm = document.querySelector("[data-contact-form-step]");
            //const contactForm: HTMLElement = document.querySelector("[data-contact-form]");
            if (doctorId === radioButton.value) {
                radioButton.checked = true;
            }
            radioButton.addEventListener("click", () => {
                if (performanceId && venueId) {
                    updateUrlParams(contactForm, `/GetContactForm?bookingFormId=${contactForm.getAttribute("data-contact-form-step")}&performanceId=${performanceId}&doctorId=${radioButton.value}&venueId=${venueId}&stepId=4`, `doctorId`, `${radioButton.value}`, handleFormValidation);
                    //updateUrlParams(contactForm, `/GetContactForm?bookingFormId=${contactForm.getAttribute("data-contact-form")}&performanceId=${performanceId}&doctorId=${radioButton.value}&venueId=${venueId}&stepId=4`, `doctorId`, `${radioButton.value}`, handleFormValidation);
                    contactFormToAppend.setAttribute("data-show", "show");
                }
                else {
                    updateUrlParams(venueContainerToAppend, `/GetVenue?performanceId=${performanceId}&doctorId=${radioButton.value}&stepId=2`, `doctorId`, `${radioButton.value}`, initVenueSelector);
                    venueContainerToAppend.setAttribute("data-show", "show");
                }
            });
        }
    });
};
